/**
 * React Flow, Radix, and Carbon charts use ResizeObserver. Browsers may report
 * "ResizeObserver loop completed with undelivered notifications" when a callback
 * triggers layout in the same frame — benign, but CRA's dev overlay treats it as fatal.
 */

const RESIZE_OBSERVER_LOOP_RE = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

window.addEventListener(
  'error',
  (event) => {
    if (RESIZE_OBSERVER_LOOP_RE.test(event.message || '')) {
      event.stopImmediatePropagation();
    }
  },
  true,
);
